import {
    Create,
    SimpleForm,
    TextInput,
    required,
} from 'react-admin';
import { NokEmailSignatureCodeEditor } from '../code-editor/NokEmailSignatureCodeEditor';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const NokEmailSignatureCreate = () => {



    return (
        <Create>
            <SimpleForm >
                <TextInput source="name" validate={[required()]} />
                <NokEmailSignatureCodeEditor  />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
